import React from "react"
import Seo from "../components/Seo"
import Layout from "../components/Layout"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import { FaQuoteLeft } from "react-icons/fa"
import GridPhotos from "../components/GridPhotos"
import Reviews from "../components/Reviews"

const cabaña = () => {
  return (
    <Layout>
      <Seo title="Cabaña" />
      <Wrapper className="section-center">
        <div className="hero">
          <StaticImage
            src="../assets/images/cabin1.jpg"
            className="hero-img"
            alt="imagen de portada"
            layout="constrained"
          />
        </div>
        <div className="cabaña-center">
          <article className="first-section flex-column">
            <StaticImage
              src="../assets/images/mar.JPG"
              className="mar-img"
              alt="vista al mar"
              layout="constrained"
            />

            <div className="first-section__content">
              <h2>Vista al mar</h2>
              <p>
                A tan solo 30 metros de la cabaña tienes este acceso y vista al
                mar. Río Chaica a metros de distancia también. Lugar
                increíblemente tranquilo.
              </p>
            </div>
          </article>
          <article className="second-section flex-column">
            <StaticImage
              src="../assets/images/cocina.jpg"
              className="second-section__first-img"
              alt="cocina"
              layout="constrained"
            />
            <StaticImage
              src="../assets/images/pieza.jpg"
              className="second-section__second-img"
              alt="pieza"
              layout="constrained"
            />
          </article>
          <article className="third-section flex-column">
            <StaticImage
              src="../assets/images/cabin-night.jpg"
              className="third-section__img"
            />
            <div className="quote">
              <FaQuoteLeft className="icon" />
              <h4>La vida consiste en disfrutar de cada instante.</h4>
              <p>Facundo Cabral.</p>
            </div>
          </article>
        </div>
      </Wrapper>
      <GridPhotos />
      <Reviews />
    </Layout>
  )
}

const Wrapper = styled.section`
  .hero {
    height: 40vh;
    .hero-img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  .cabaña-center {
    width: 90vw;
    margin: 0 auto;
    max-width: 992px;
  }

  .first-section {
    padding: 4rem 0;

    .mar-img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    .first-section__content {
      padding: 1rem 2rem;
      letter-spacing: var(--letterSpacing);
    }
  }

  .second-section {
    .second-section__first-img {
      width: 100%;
      height: 100%;
      padding: 0 1rem;
      margin-bottom: 2rem;
    }
    .second-section__second-img {
      width: 100%;
      height: 100%;
      padding: 0 2rem;
      margin-bottom: 1rem;
    }
  }

  .third-section {
    justify-content: center;
    .third-section__img {
      width: 100%;
    }
  }

  .quote {
    padding: 3rem 1rem;
    .icon {
      font-size: 2.5rem;
    }

    h4 {
      font-weight: 400;
    }
    p {
      color: var(--grey-700);
    }
  }

  /* queries */
  @media screen and (min-width: 768px) {
    .quote {
      width: 95%;
    }
  }

  @media screen and (min-width: 992px) {
    .quote {
      padding-left: 3rem;
      h4 {
        font-size: 3rem;
      }
    }

    .hero {
      height: 80vh;
    }

    .first-section {
      .mar-img {
        width: 65%;
      }
      .first-section__content {
        width: 35%;
      }
    }

    .second-section {
      padding: 4rem 0;
      .second-section__first-img {
        width: 50%;
        margin-bottom: 0;
      }
      .second-section__second-img {
        width: 30%;
        margin-bottom: 0;
      }
    }
  }

  .third-section__img {
    width: 70%;
  }
`

export default cabaña
